module.exports = __webpack_public_path__ + "static/media/tm-colorit-12.d3ebd5f7.webp";